/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import { initPaymentResponseSchema } from "./initPaymentResponseSchema.ts";
import { reservePrepaymentRequestSchema } from "./reservePrepaymentRequestSchema.ts";

export const orgUnitReservePaymentCreatePathOrgUnitIdSchema = z.uuid();

export const orgUnitReservePaymentCreatePathReserveIdSchema = z.uuid();

export const orgUnitReservePaymentCreateStatus201Schema = initPaymentResponseSchema.describe("url is nullable for payments from kiosk");

export const orgUnitReservePaymentCreateResponseSchema = orgUnitReservePaymentCreateStatus201Schema;

export const orgUnitReservePaymentCreateDataSchemaJson = reservePrepaymentRequestSchema
	.optional()
	.describe("Предоплата банкета: сумму можно не передавать — тогда платится остаток.");

export const orgUnitReservePaymentCreateDataSchemaXml = reservePrepaymentRequestSchema
	.optional()
	.describe("Предоплата банкета: сумму можно не передавать — тогда платится остаток.");

export const orgUnitReservePaymentCreateDataSchema = z.union([orgUnitReservePaymentCreateDataSchemaJson, orgUnitReservePaymentCreateDataSchemaXml]);
